<template>
  <div class="authenticate">
    <v-container fluid>
      <v-layout row>
        <v-flex xs12>
          <v-text-field
            name="input-1"
            label="Emailadres"
            id="testing"
            v-model="emailAddress"
            @change="$emit('emailaddressEntered', emailAddress)"
          > </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-text-field
            name="input-10-1"
            label="Enter your password"
            hint="At least 8 characters"
            v-model="password"
            min="8"
            :append-icon="e1 ? 'visibility' : 'visibility_off'"
            :append-icon-cb="() => (e1 = !e1)"
            :type="e1 ? 'password' : 'text'"
            @change="$emit('passwordEntered', password)"
            counter
          > </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <router-link to="/">
            <v-btn @click="$emit('confirmed')" color="blue">Bevestigen</v-btn>
          </router-link>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'credentials',
    data () {
      return {
        e1: true,
        emailAddress: '',
        password: ''
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Credentials.vue?50d9ece0